import type { IpContent } from './types';

/**
 * Копия лендинга /ip (русская).
 *
 * Правишь текст страницы — правишь этот файл, больше ничего. Вёрстка в
 * routes/landing/, лоты в нишах и числа приходят из API. Источник: макет
 * docs/superpowers/specs/2026-08-14-landings-mockups/landing-ip.html.
 */
export const ipRu: IpContent = {
  kind: 'ip',
  pageTitle: 'Госзакупки для начинающих — тендеры вашего размера | UzTender',
  metaDescription:
    'Государство каждый день покупает обеды, ремонт, доставку и даже цветы. Тендеры до 100 млн сум, контакты заказчиков и понятные описания — 79 000 сум в месяц. Отмена в любой момент.',
  nav: [
    { label: 'Тендеры', href: '#lots' },
    { label: 'С чего начать', href: '#start' },
    { label: 'Цена', href: '#pricing' },
    { label: 'Вопросы', href: '#faq' },
  ],
  heroKicker: 'Для тех, кто хочет работать с госзаказом',
  heroH1: 'Начните участвовать в госзакупках — с маленьких тендеров',
  heroLead:
    'Государство каждый день покупает обеды, ремонт, доставку и даже цветы. Мы показываем тендеры до 100 млн сум, даём контакты заказчиков, а новые тендеры приходят вам сами.',
  // Отступление 10 (ревью владельца, 2026-08-18): хиро-CTA больше не ведёт
  // на /plans — только кнопки ВНУТРИ блока «Цена» (см. types.ts, `plan.cta`
  // ниже) продают тариф. Здесь — переход на каталог.
  ctaPrimary: 'Перейти к площадке',
  ctaHeader: 'Перейти к площадке',
  ctaSecondary: 'Показать тендеры моего размера ↓',
  heroMicro: 'Отмена в любой момент. Смотреть каталог можно бесплатно.',
  sourcesLabel: 'Если тендера нет у нас — его нет нигде:',
  sources: ['xarid.uzex.uz', 'etender.uzex.uz', 'xt-xarid.uz'],
  // Отступление 7: см. start.ru.ts — N считается на сервере, не захардкожен.
  sourcesMoreLabel: 'и ещё {count} площадок',
  sourcesUpdateNote: '· обновляем каждые 2 часа',
  heroChatNotice: {
    title: '🔔 Новый тендер по поиску «цветы»',
    body: 'город Ташкент',
    time: '08:41',
  },
  heroChatReply: 'А это мне по силам 👌',
  lotsKicker: 'Не примеры из рекламы — живой каталог',
  lotsTitle: 'Что вы умеете делать?',
  lotsLead:
    'Нажмите на свою нишу — покажем настоящие тендеры до 100 млн сум, открытые прямо сейчас. Любой можно открыть и прочитать.',
  niches: [
    { key: 'auto', label: 'Авторемонт', categoryName: 'Автомобили и транспорт' },
    { key: 'food', label: 'Питание и продукты', categoryName: 'Продукты питания' },
    { key: 'transport', label: 'Доставка и перевозки', categoryName: 'Транспорт и логистика' },
    { key: 'cleaning', label: 'Клининг и услуги', categoryName: 'Клининг и санитария' },
    { key: 'it', label: 'Компьютеры и ИТ', categoryName: 'ИТ и телекоммуникации' },
    { key: 'furniture', label: 'Мебель и офис', categoryName: 'Мебель и интерьер' },
    { key: 'textile', label: 'Текстиль и швейка', categoryName: 'Текстиль и одежда' },
    { key: 'flowers', label: 'Цветы и озеленение', categoryName: 'Сельское хозяйство' },
  ],
  foundTemplate: 'В категории «{category}» сейчас {count} активных {word}',
  seeAllLabel: 'смотреть все →',
  // Отступление 11 (ревью владельца, 2026-08-20): «1 из 5» (21,7%, отступление
  // 8) заменено на «1 из 3» — не новое измерение, а честная оценка внутри
  // пол/потолок вилки. Только ОДИН источник (etender) вообще пишет исход
  // «без победителя»; остальные хранят только победы. Значит доля по ВСЕМ
  // источникам (21,7% за 90 дней) — это ПОЛ, не факт: источники без учёта
  // проигрышей тянут её вниз. У etender — единственного с полным трекингом —
  // 56% за 90 дней / 88% за всё время: это ПОТОЛОК. «1 из 3» (≈27–33%) лежит
  // внутри этой вилки — консервативная оценка аналитика, не мокапная цифра.
  // factBig читается слитно с factBody («1 из 3 тендеров закрывается…»).
  factBig: '1 из 3',
  factBody:
    'тендеров закрывается без победителя — заказчик не находит поставщика. Конкуренция ниже, чем кажется.',
  lotsCta: 'Открыть весь каталог — бесплатно',
  lotsMicro:
    'Без регистрации. Фильтры по региону, категории и сумме. Описания на русском и узбекском.',
  fearsTitle: 'Три сомнения перед стартом',
  fearsLead: 'Слышим их каждый день. Отвечаем коротко.',
  fears: [
    {
      q: '«Как вообще подать заявку?»',
      title: 'Есть гид — 15 минут',
      body: 'От открытия ИП до первой заявки, по шагам. Открыть гид — бесплатно.',
    },
    {
      q: '«Это можно без вложений заниматься?»',
      title: 'Большие деньги не нужны',
      // Отступление 3: формулировка про 250 000 сум при 25 млн оставлена как есть — медиана ровно 1,00%.
      body: 'Обеспечение на маленьких тендерах небольшое: например, 250 000 сум при тендере в 25 млн. В услугах товар заранее закупать не надо.',
    },
    {
      q: '«А если что-то непонятно в требованиях?»',
      title: 'Спросите у заказчика напрямую',
      body: 'В подписке у каждого тендера есть контакт заказчика — позвоните и уточните до подачи.',
    },
  ],
  valueTitle: 'Что даёт подписка за 79 000',
  values: [
    {
      title: '5 контактов заказчиков в месяц',
      body: 'Телефон и данные заказчика по тендерам, которые вам подошли. На 1–2 заявки в месяц хватает с запасом.',
    },
    {
      title: 'Только тендеры до 100 млн',
      body: 'Без миллиардных строек. Видите то, за что реально можно взяться маленькой фирме или ИП.',
    },
    {
      title: 'Новые тендеры приходят сами',
      body: 'Сохранили поиск — например, «ремонт, Фергана» — и новое приходит уведомлением. Каталог можно не листать.',
    },
    {
      title: 'Понятно, что от вас хотят',
      body: 'У каждого тендера — короткое описание на русском и узбекском: что купить, за сколько и к какому сроку.',
    },
  ],
  // Отступление 9 (ревью владельца, 2026-08-18): старые 4 шага (открыть ИП →
  // E-IMZO → регистрация на площадке → старт с малого) описывали путь ДО
  // подписки. Новые — путь внутри сервиса: зарегистрироваться у нас,
  // настроить уведомления, выбрать тендер, подать заявку на площадке.
  stepsTitle: 'Как начать — 4 шага',
  steps: [
    { title: 'Зарегистрируйтесь на UzTender', body: 'Бесплатно, за минуту' },
    { title: 'Настройте уведомления', body: 'Сохраните нишу — новые тендеры придут сами' },
    { title: 'Выберите подходящий тендер', body: 'Из присланных или прямо из каталога' },
    { title: 'Подайте заявку на сайте площадки', body: 'На xarid.uzex.uz или xt-xarid.uz' },
  ],
  stepsCta: 'Открыть гид для поставщиков — бесплатно',
  stepsMicro: 'В гиде разобран каждый шаг: документы, сроки и частые ошибки новичков.',
  pricingTitle: 'Один тариф. Без мелкого шрифта',
  plan: {
    name: 'ИП',
    priceMonthly: '79 000 сум/мес',
    priceYearly: null,
    wasYearly: null,
    noteMonthly: '',
    noteYearly: '',
    features: [
      '5 контактов заказчиков в месяц',
      'Тендеры с бюджетом до 100 млн сум',
      'Сохранённые поиски и уведомления — без ограничений',
      'Разбор и требования ТЗ — бесплатно',
    ],
    yearlyOnlyFeatures: [],
    // Отступление 8.
    cta: 'Начать за 79 000 сум',
    highlighted: true,
    flag: null,
    note: null,
  },
  planMicro: 'Оплата через Payme · Отмена в любой момент',
  mathTitle: 'Простая математика',
  // Отступление: «наценка 10%» → «прибыль 25%» — 25% от 30 млн это 7 500 000,
  // а 7 500 000 / 79 000 = 94,9 → 94 месяца (94 mod 10 = 4, 94 не в 11–14 →
  // «месяца», см. pluralRu в lib/format.ts).
  mathRows: [
    { label: 'Выиграли один тендер на', value: '30 млн сум', highlight: false },
    { label: 'Ваша прибыль 25%', value: '7 500 000 сум', highlight: true },
    { label: 'Подписка в месяц', value: '79 000 сум', highlight: false },
    { label: 'Этих денег хватит на', value: '94 месяца', highlight: true },
  ],
  mathMicro: 'Тендеры такого размера выходят каждый день — вы видели их выше, и все они настоящие.',
  upsell:
    'Подаёте много заявок? Есть Pro — 399 000 сум/мес: контакты без лимита, документы тендеров и цены победителей.',
  teamTitle: 'Кто за этим стоит',
  // Отступление 4: команда — две карточки (CEO + CTO), тот же блок, что на
  // /start, без официоза — фото крупнее (см. комментарий в start.ru.ts).
  // Отступление 6 (2026-08-18): `bio` убран целиком — карточка теперь только
  // фото + имя + роль.
  team: [
    {
      name: 'Игорь Ким',
      role: 'CEO',
      photo: '/img/team/igor.jpg',
      initials: 'ИК',
      links: [
        { label: '@flesteyto', href: 'https://t.me/flesteyto', primary: true },
        { label: '+998 90 187-77-98', href: 'tel:+998901877798', primary: false },
      ],
    },
    {
      name: 'Константин Цой',
      role: 'CTO',
      photo: '/img/team/konstantin.jpg',
      initials: 'КЦ',
      links: [],
    },
  ],
  // Отступление 5: «Резидент IT Park» не публикуем.
  fineprint: [
    { label: 'ООО «FASTAGO»', href: null },
    { label: 'ИНН 306377222', href: null },
    { label: 'Ташкент', href: null },
    { label: 'Полные реквизиты →', href: '/requisites' },
  ],
  faqTitle: 'Частые вопросы',
  faq: [
    {
      q: 'Нужно ли ООО или хватит ИП?',
      a: 'Для большинства маленьких тендеров хватает ИП. Требования каждого тендера видны в его карточке. В гиде разобрано, когда ООО действительно нужно.',
    },
    // Отступление 6: вопрос «Сколько стоит ЭЦП и где её получить?» убран целиком.
    {
      q: 'Нужен ли залог или большие деньги на старте?',
      a: 'На маленьких тендерах обеспечение — небольшой процент от суммы. Например, 250 000 сум на тендере в 25 млн. Точная сумма всегда видна в карточке до подачи. В услугах закупать товар заранее не нужно.',
    },
    {
      q: 'А если в моей сфере нет тендеров?',
      a: 'Проверьте до оплаты — каталог открыт: 31 категория и все 14 регионов. Сомневаетесь — напишите нам, посмотрим вашу нишу вместе.',
    },
    {
      q: 'Чем тариф ИП отличается от Pro?',
      a: 'ИП (79 000 сум) — для старта: тендеры до 100 млн и 5 контактов в месяц. Pro (399 000 сум) — контакты без лимита, документы тендеров, цены победителей, Telegram-бот. Перейти на Pro можно в любой момент.',
    },
    {
      q: 'Как отменить подписку?',
      a: 'В любой момент, в пару кликов в личном кабинете. Доступ работает до конца оплаченного срока, дальше деньги не списываются.',
    },
  ],
  finalH2: 'Государство уже покупает то, что вы умеете',
  // Отступление 9: «Сегодня» → «за неделю» ({count} подставляет страница).
  finalLead:
    'Вопрос только — у кого. За неделю в каталоге появилось {count} новых {word}. Среди них есть и ваши.',
  // Отступление 10.
  finalCtaPrimary: 'Перейти к площадке',
  footerLinks: [
    { label: 'О сервисе', href: '/about' },
    { label: 'Гид для поставщиков', href: '/guide' },
    { label: 'Тарифы', href: '/plans' },
    { label: 'Публичная оферта', href: '/offer' },
    { label: 'Конфиденциальность', href: '/privacy' },
    { label: 'Реквизиты', href: '/requisites' },
    { label: '@flesteyto', href: 'https://t.me/flesteyto' },
    { label: '+998 90 187-77-98', href: 'tel:+998901877798' },
  ],
  footerLegal: '© 2026 ООО «FASTAGO». Все права защищены. ИНН: 306377222',
  stickyTitle: '79 000 сум/мес',
  stickySubtitle: 'отмена в любой момент',
  // Отступление 10.
  stickyCta: 'Перейти к площадке',
};
